var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEigenesTempo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 367.41 490.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#ffc358;}.cls-4{fill:#575756;}.cls-3,.cls-5{stroke-linecap:round;stroke-width:11px;}.cls-3,.cls-5,.cls-6{stroke:#575756;stroke-miterlimit:10;}.cls-5,.cls-6{fill:none;}.cls-6{stroke-width:9px;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "Eigenes_Tempo",
    viewBox: "0 0 367.41 490.57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Tacho"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 183.7,
    cy: 131.75,
    r: 127.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 290.59,
    y1: 131.22,
    x2: 269.7,
    y2: 131.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 279.78,
    y1: 84.9,
    x2: 261,
    y2: 94.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 249.94,
    y1: 47.86,
    x2: 237,
    y2: 64.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 206.99,
    y1: 27.43,
    x2: 202.44,
    y2: 47.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.43,
    y1: 27.66,
    x2: 164.17,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 116.67,
    y1: 48.49,
    x2: 129.77,
    y2: 64.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 87.19,
    y1: 85.82,
    x2: 106.05,
    y2: 94.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 76.81,
    y1: 132.23,
    x2: 97.7,
    y2: 132.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 184.69,
    cy: 131.34,
    r: 21.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "237.99 65.99 171.44 130.73 185.01 142.24 237.99 65.99"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m367.41,165.32v236.46c0,1.64-.95,3.14-2.44,3.84l-144.89,68.26c-9.16,10.61-22.36,16.69-36.38,16.69s-27.21-6.08-36.37-16.69L2.43,405.62c-1.49-.7-2.43-2.2-2.43-3.84v-236.46c0-1.46.74-2.81,1.97-3.59s2.77-.87,4.09-.26l16.9,7.97,17.23-12.71c1.18-.87,2.72-1.08,4.08-.53,24.51,9.66,46.18,11.46,65.29,13.05,32.14,2.66,58.06,4.85,74.14,44.12,16.09-39.28,42.01-41.46,74.14-44.13,19.12-1.58,40.79-3.38,65.29-13.04,1.36-.54,2.91-.34,4.09.53l17.23,12.71,16.9-7.97c1.31-.61,2.86-.52,4.09.26,1.22.78,1.97,2.13,1.97,3.59Zm-8.5,233.76v-227.06l-137.19,64.63v227.06l137.19-64.63Zm-143.25-168.97l120.05-56.56-11.66-8.6c-24.75,9.38-46.37,11.18-65.5,12.77-34.27,2.84-56.91,4.72-70.79,49.51,0,0,0,.01-.01.01-.4,1.29-1.4,2.36-2.79,2.79-.42.13-.84.19-1.26.19-1.81,0-3.49-1.17-4.06-2.99-13.87-44.79-36.51-46.67-70.78-49.51-19.14-1.59-40.75-3.38-65.5-12.77l-11.66,8.6,120.05,56.56c.64.29,1.39,1.05,1.46,1.13,7.56,9.13,18.68,14.37,30.49,14.37s22.93-5.24,30.5-14.37c.06-.08.9-.87,1.46-1.13Zm-2.44,238.73v-224.87c-8.37,6.53-18.7,10.14-29.52,10.14s-21.15-3.61-29.51-10.14v224.87c7.52,8.42,18.2,13.23,29.51,13.23s21.99-4.81,29.52-13.23Zm-67.54-5.13v-227.06L8.5,172.02v227.06l137.18,64.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m358.91,172.02v227.06l-137.19,64.63v-227.06l137.19-64.63Zm-21.65,94.52v-40.57c0-1.45-.74-2.81-1.97-3.59s-2.77-.87-4.09-.25l-85.4,40.23c-1.48.7-2.43,2.2-2.43,3.84v40.57c0,1.46.74,2.81,1.97,3.59.69.44,1.48.66,2.28.66.61,0,1.23-.13,1.81-.4l85.39-40.23c1.49-.7,2.44-2.2,2.44-3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m337.26,225.97v40.57c0,1.65-.95,3.15-2.44,3.85l-85.39,40.23c-.58.27-1.2.4-1.81.4-.8,0-1.59-.22-2.28-.66-1.23-.78-1.97-2.13-1.97-3.59v-40.57c0-1.64.95-3.14,2.43-3.84l85.4-40.23c1.32-.62,2.86-.53,4.09.25s1.97,2.14,1.97,3.59Zm-8.5,37.88v-31.18l-76.89,36.23v31.17l76.89-36.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m335.71,173.55l-120.05,56.56c-.56.26-1.4,1.05-1.46,1.13-7.57,9.13-18.68,14.37-30.5,14.37s-22.93-5.24-30.49-14.37c-.07-.08-.82-.84-1.46-1.13l-120.05-56.56,11.66-8.6c24.75,9.39,46.36,11.18,65.5,12.77,34.27,2.84,56.91,4.72,70.78,49.51.57,1.82,2.25,2.99,4.06,2.99.42,0,.84-.06,1.26-.19,1.39-.43,2.39-1.5,2.79-2.79.01,0,.01-.01.01-.01,13.88-44.79,36.52-46.67,70.79-49.51,19.13-1.59,40.75-3.39,65.5-12.77l11.66,8.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "328.76 232.67 328.76 263.85 251.87 300.07 251.87 268.9 328.76 232.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m213.22,243.97v224.87c-7.53,8.42-18.2,13.23-29.52,13.23s-21.99-4.81-29.51-13.23v-224.87c8.36,6.53,18.69,10.14,29.51,10.14s21.15-3.61,29.52-10.14Zm-13.36,49.59c2.21-.79,3.36-3.22,2.57-5.43s-3.23-3.36-5.43-2.57c-8.59,3.07-18.01,3.07-26.59,0-2.21-.79-4.65.36-5.44,2.57s.36,4.64,2.57,5.43c5.22,1.87,10.65,2.82,16.16,2.82s10.95-.95,16.16-2.82Zm0,155.14c2.21-.79,3.36-3.23,2.57-5.44s-3.23-3.36-5.43-2.56c-8.59,3.07-18.01,3.07-26.59,0-2.21-.8-4.65.35-5.44,2.56s.36,4.65,2.57,5.44c5.22,1.87,10.65,2.81,16.16,2.81s10.95-.94,16.16-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.43,288.13c.79,2.21-.36,4.64-2.57,5.43-5.21,1.87-10.65,2.82-16.16,2.82s-10.94-.95-16.16-2.82c-2.21-.79-3.36-3.22-2.57-5.43s3.23-3.36,5.44-2.57c8.58,3.07,18,3.07,26.59,0,2.2-.79,4.64.36,5.43,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m202.43,443.26c.79,2.21-.36,4.65-2.57,5.44-5.21,1.87-10.65,2.81-16.16,2.81s-10.94-.94-16.16-2.81c-2.21-.79-3.36-3.23-2.57-5.44s3.23-3.36,5.44-2.56c8.58,3.07,18,3.07,26.59,0,2.2-.8,4.64.35,5.43,2.56Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "145.68 236.65 145.68 463.71 8.5 399.08 8.5 172.02 145.68 236.65"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("use", {
    width: 367.41,
    height: 490.57,
    xlinkHref: "#Eigenes_Tempo"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEigenesTempo);
export default __webpack_public_path__ + "static/media/Icon_Eigenes_Tempo.45d3dfa3b28eef548df3d261df168172.svg";
export { ForwardRef as ReactComponent };